/**
 * Saved segments — Phase 5b replacement.
 * Delegates to /api/reports/{reportId}/saved-segments on dash-api.
 */

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token
        ? {'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json'}
        : {'Content-Type': 'application/json'};
}

async function apiFetch(path, opts = {}) {
    const resp = await fetch(`${BASE}${path}`, {headers: authHeaders(), ...opts});
    if (resp.status === 404) return null;
    if (!resp.ok) throw new Error(`${opts.method || 'GET'} ${path} → ${resp.status}`);
    if (resp.status === 204) return null;
    return resp.json();
}

export const saveSearchResult = async (reportId, segmentData) => {
    await apiFetch(`/api/reports/${encodeURIComponent(reportId)}/saved-segments`, {
        method: 'POST',
        body: JSON.stringify(segmentData),
    });
};

export const getReportSavedSegments = async (reportId) => {
    const data = await apiFetch(`/api/reports/${encodeURIComponent(reportId)}/saved-segments`);
    if (!data) return [];
    return Array.isArray(data) ? data : (data.references || []);
};

export const clearReportSavedSegments = async (reportId) => {
    await apiFetch(`/api/reports/${encodeURIComponent(reportId)}/saved-segments`, {
        method: 'DELETE',
    });
};

export const deleteSavedSegment = async (reportId, segmentIndex) => {
    await apiFetch(
        `/api/reports/${encodeURIComponent(reportId)}/saved-segments/${segmentIndex}`,
        {method: 'DELETE'}
    );
};
